const NORMAL = 'normal'
const FIXED = 'fixed'
const PROPORTIONAL = 'proportional'

export {
    NORMAL,
    FIXED,
    PROPORTIONAL
}